import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'buscador'})
export class BuscadorPipe implements PipeTransform {
    transform(items: any[], filter: String, args: any[]): any {
        if (!items || !filter) {
            return items;
        } else if (args) {
            let result: any[];

            result = items.filter(function(item){
                let encontroAlgo = false;
                args.forEach(element => {
                    if (!encontroAlgo && item[element]) {
                        encontroAlgo = item[element].toUpperCase().indexOf(filter.toUpperCase()) !== -1;
                    }
                });
                return encontroAlgo;
            });

            return result;
        }
        return items.filter(item => item.Nombre.toUpperCase().indexOf(filter.toUpperCase()) !== -1);
    }
}


// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/pipes/buscador.pipe.ts